import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, X } from 'lucide-react';
import { Button } from './Shared';
export function TopBar() {
  return <div className="bg-brand-red text-white text-xs md:text-sm font-medium py-2 overflow-hidden relative z-50" data-id="element-109">
      <div className="flex w-max animate-[scroll_25s_linear_infinite]" data-id="element-110">
        {[...Array(2)].map((_, i) => <div key={i} aria-hidden={i === 1} className="flex items-center gap-8 px-4 whitespace-nowrap shrink-0" data-id="element-111">
            <span data-id="element-112">Oferta de lanzamiento disponible hoy</span>
            <span className="w-1 h-1 bg-white/50 rounded-full" data-id="element-113" />
            <span data-id="element-114">Acceso inmediato + bonos incluidos</span>
            <span className="w-1 h-1 bg-white/50 rounded-full" data-id="element-115" />
            <span data-id="element-116">Edición de lanzamiento con precio especial</span>
            <span className="w-1 h-1 bg-white/50 rounded-full" data-id="element-117" />
            <span data-id="element-118">Hoy entrás al archivo con beneficios exclusivos</span>
            <span className="w-1 h-1 bg-white/50 rounded-full" data-id="element-119" />
          </div>)}
      </div>
    </div>;
}
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-120">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-brand-dark/90 backdrop-blur-md border-t border-brand-card z-40 md:hidden" data-id="element-121">
          <Button fullWidth onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-122">
            QUIERO ACCEDER AHORA
          </Button>
        </motion.div>}
    </AnimatePresence>;
}
const notifications = [{
  name: 'María',
  location: 'Bogotá'
}, {
  name: 'Lucas',
  location: 'Buenos Aires'
}, {
  name: 'Ana',
  location: 'Ciudad de México'
}, {
  name: 'Diego',
  location: 'Santiago'
}, {
  name: 'Camila',
  location: 'Lima'
}];
export function PurchaseNotifications() {
  const [currentNotification, setCurrentNotification] = useState<number | null>(null);
  useEffect(() => {
    // Initial delay of 12-15 seconds
    const initialDelay = Math.floor(Math.random() * 3000) + 12000;
    const showNextNotification = () => {
      const randomIndex = Math.floor(Math.random() * notifications.length);
      setCurrentNotification(randomIndex);
      // Hide after 5 seconds
      setTimeout(() => {
        setCurrentNotification(null);
      }, 5000);
    };
    const initialTimer = setTimeout(() => {
      showNextNotification();
      // Show subsequent notifications every 20-30 seconds
      setInterval(() => {
        showNextNotification();
      }, Math.floor(Math.random() * 10000) + 20000);
    }, initialDelay);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-123">
      {currentNotification !== null && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.9,
      transition: {
        duration: 0.2
      }
    }} className="fixed bottom-24 md:bottom-8 left-4 md:left-8 z-50 bg-brand-card border border-brand-anthracite shadow-2xl rounded-lg p-3 flex items-center gap-3 max-w-[280px]" data-id="element-124">
          <div className="bg-brand-dark p-2 rounded-full border border-brand-gold/30" data-id="element-125">
            <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-126" />
          </div>
          <div className="flex-1" data-id="element-127">
            <p className="text-xs text-brand-offWhite font-medium" data-id="element-128">
              <span className="font-bold text-white" data-id="element-129">
                {notifications[currentNotification].name}
              </span>{' '}
              de {notifications[currentNotification].location}
            </p>
            <p className="text-[10px] text-brand-muted mt-0.5" data-id="element-130">
              acaba de acceder a la colección
            </p>
          </div>
          <button onClick={() => setCurrentNotification(null)} className="text-brand-muted hover:text-white" data-id="element-131">
            <X className="w-3 h-3" data-id="element-132" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}